import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  DestroyRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FeatureFlagService } from '../../feature-flag/services/feature-flag.service';

@Directive({
  selector: '[appFeatureFlag]',
  standalone: true,
})
export class FeatureFlagDirective {
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly tpl: TemplateRef<unknown>,
    private readonly vcr: ViewContainerRef,
    private readonly featureFlagService: FeatureFlagService,
  ) {}

  @Input('appFeatureFlag')
  set flagName(flagName: string) {
    this.featureFlagService
      .hasFlag$(flagName)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((enabled: boolean) => {
        this.vcr.clear();
        if (enabled) {
          this.vcr.createEmbeddedView(this.tpl);
        }
      });
  }
}
